const oktaClientID = process.env.OKTA_CLIENT_ID || 'dummyClientID';
const oktaIssuer =
  process.env.OKTA_ISSUER || 'https://striim.okta.com/oauth2/default';
const redirectURL = window.location.origin + '/login/callback';

export default {
  oidc: {
    clientId: oktaClientID,
    issuer: oktaIssuer,
    postLogoutRedirectUri: window.location.origin,
    redirectUri: redirectURL,
    restoreOriginalUri: async (_oktaAuth, originalUri) => {
      if (originalUri) {
        window.location.replace(originalUri);
      }
    },
    scopes: ['openid', 'profile', 'email'],
    pkce: true,
  },
};



// WEBPACK FOOTER //
// ./client/config.js